import { Info, TriangleAlert } from "lucide-react";

import s from "./Notice.module.css";

// One visual shell for "this cannot be submitted, and here is why". Every such message
// used to be styled where it was written — the vaccine form carried three copies of the
// same inline style object — so the same kind of problem looked like three different
// kinds of problem stacked on top of each other.
//
// `action` is an optional element (typically a Button) shown at the right end: a notice
// that says what is wrong should, where it can, offer the way to fix it.
//
// The tone carries the icon and the ARIA role with it: "this cannot be submitted" is an
// alert with a warning triangle, while "here is how things stand" is a status with an
// info mark — announcing the latter as an alert interrupts a screen reader for news that
// is not urgent.
const TONE_ICONS = {
  blocking: TriangleAlert,
  info: Info,
};

const TONE_ROLES = {
  blocking: "alert",
  info: "status",
};

export const Notice = ({
  children,
  action,
  tone = "blocking",
  isStacked = false,
  testId,
}) => {
  const ToneIcon = TONE_ICONS[tone] || TriangleAlert;

  return (
    <div
      className={`${s.notice} ${s[tone]} ${isStacked ? s.stacked : ""}`}
      role={TONE_ROLES[tone] || "alert"}
      data-testid={testId}
    >
      <ToneIcon size={20} className={s.icon} />
      <div className={s.body}>{children}</div>
      {!!action && <div className={s.action}>{action}</div>}
    </div>
  );
};

export const NoticeText = ({ children, isLead = false }) => (
  <p className={`${s.text} ${isLead ? s.lead : ""}`}>{children}</p>
);

export const NoticeList = ({ children }) => (
  <ul className={s.list}>{children}</ul>
);
